import { AppSettingsService } from 'src/@dva/services/app-settings.service';
import { HttpParams } from '@angular/common/http';
import { HttpRequestService } from 'src/@dva/services/http-request.service';
import { Injectable } from '@angular/core';
import { Workflow } from './models/workflow.model';
import { WorkflowItem } from './models/workflow-item.model';

@Injectable({
  providedIn: 'root',
})
export class ProgressPanelService {
  constructor(private appSettingsService: AppSettingsService, private httpRequestService: HttpRequestService) {}

  getByDateAndCompanyId(date: string, companyId: number) {
    const params = new HttpParams().set('date', date).set('companyId', companyId.toString());
    return this.httpRequestService.getQueryString<Workflow[]>(
      this.appSettingsService.getApiEndpointValidator(),
      'ValidationWorkflows/',
      params,
    );
  }

  reprocessByWorkflowId(workflowId: number) {
    return this.httpRequestService.put<any>(
      this.appSettingsService.getApiEndpointProcess(),
      `File/Reprocess/${workflowId}`,
    );
  }

  cancelByWorkflowId(workflowId: number) {
    return this.httpRequestService.put<any>(
      this.appSettingsService.getApiEndpointValidator(),
      `ValidationWorkflows/${workflowId}/cancel`,
    );
  }

  getItemsById(workflowId: number) {
    return this.httpRequestService.get<WorkflowItem[]>(
      this.appSettingsService.getApiEndpointValidator(),
      `ValidationWorkflows/${workflowId}/items`,
    );
  }
}
